import { Link } from 'react-router-dom';
import { FiBookOpen, FiSearch, FiMessageSquare, FiBook, FiArrowRight } from 'react-icons/fi';

/**
 * Página informativa de Biblia de Estudio (para acceder desde el Home)
 */
export default function BibliaInfo() {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl shadow-xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4 mb-4">
            <FiBook className="w-12 h-12" />
            <h1 className="text-4xl font-bold">
              Biblia de Estudio
            </h1>
          </div>
          <p className="text-xl text-blue-50 mb-6">
            Herramienta completa para el estudio de las Escrituras con comentarios, referencias cruzadas y análisis.
          </p>
          
          <Link
            to="/biblia-estudio"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-colors shadow-lg"
          >
            Ir a Estudio Bíblico
            <FiArrowRight className="w-5 h-5" />
          </Link>
        </div>

        {/* Características */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-md p-6">
            <FiBookOpen className="w-8 h-8 text-blue-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Múltiples Traducciones
            </h3>
            <p className="text-gray-600">
              Accede a diferentes versiones de la Biblia en hebreo, griego, arameo y español.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiSearch className="w-8 h-8 text-blue-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Búsqueda Avanzada
            </h3>
            <p className="text-gray-600">
              Busca palabras, frases y conceptos con filtros avanzados y concordancia Strong.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiMessageSquare className="w-8 h-8 text-blue-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Comentarios y Notas
            </h3>
            <p className="text-gray-600">
              Añade tus propias notas y accede a comentarios de estudiosos reconocidos.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <FiBook className="w-8 h-8 text-blue-600 mb-3" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Referencias Cruzadas
            </h3>
            <p className="text-gray-600">
              Explora conexiones entre pasajes y profundiza en el contexto bíblico.
            </p>
          </div>
        </div>

        {/* Funcionalidades Disponibles */}
        <div className="bg-white rounded-xl shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Funcionalidades Disponibles
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Lectura de Versículos</h4>
                <p className="text-gray-600 text-sm">Navega por libros, capítulos y versículos con interfaz intuitiva. Permite agregar múltiples versiones bíblicas en paralelo.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Panel de Strong's</h4>
                <p className="text-gray-600 text-sm">Haz clic sobre cualquier número Strong para ver el análisis de la palabra original en hebreo o griego en el panel inferior.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Comparación de Versiones</h4>
                <p className="text-gray-600 text-sm">Compara el mismo pasaje en diferentes traducciones lado a lado para un estudio más profundo.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Notas Personales (Usuarios Registrados)</h4>
                <p className="text-gray-600 text-sm">Crea y organiza tus propias notas de estudio. Sincroniza entre dispositivos.</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                ✓
              </div>
              <div>
                <h4 className="font-semibold text-gray-900">Acceso para Usuarios No Registrados</h4>
                <p className="text-gray-600 text-sm">Puedes leer la Biblia sin necesidad de registro. Regístrate solo si deseas guardar notas personales.</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-8 text-center">
          <Link
            to="/biblia-estudio"
            className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 text-white rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors shadow-lg"
          >
            <FiBook className="w-5 h-5" />
            Comenzar a Estudiar
          </Link>
        </div>
      </div>
    </div>
  );
}






